import { render, staticRenderFns } from "./means.vue?vue&type=template&id=20aa6f0a&scoped=true&"
import script from "./means.vue?vue&type=script&lang=js&"
export * from "./means.vue?vue&type=script&lang=js&"
import style0 from "./means.vue?vue&type=style&index=0&id=20aa6f0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aa6f0a",
  null
  
)

export default component.exports